import React from 'react';
import cx from 'classnames';
import styles from './menu.module.scss';
import useAccessibleFocus from '../../../common/hooks/useAccessibleFocus';
import { useTranslation } from 'react-i18next';

const Menu = React.forwardRef(({ listMode, children, onMouseLeave, simple, customStyles, className, onClose }, ref) => {
  const myRef = useAccessibleFocus(true, ref);
  const { t } = useTranslation();

  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && onClose) {
      onClose();
    }
  };

  if (simple) {
    return (
      <ul tabIndex={0} ref={myRef} style={{ ...customStyles }} className={cx(styles.simpleMenu, className)} onMouseLeave={onMouseLeave} role="menu" onKeyDown={handleKeyDown}>
        {children}
      </ul>
    );
  }

  return (
    <ul
      ref={myRef}
      tabIndex={0}
      style={{ ...customStyles }}
      className={cx(styles.menu, listMode ? styles.menuList : styles.menuCard, className)}
      onMouseLeave={onMouseLeave}
      onClick={e => e.stopPropagation()}
      aria-label={t('accessibility.menu')}
      onKeyDown={handleKeyDown}
    >
      {children}
    </ul>
  );
});

export default Menu;
